import { useState, useEffect } from "react";

export function useScrolledBottom(initValue = true) {
  const [isScrolledBottom, setIsScrolledBottom] = useState(initValue);
  useEffect(() => {
    function scrollHandler() {
      if (typeof window !== "undefined") {
        if (window.scrollY >= document.body.scrollHeight - window.innerHeight) {
          setIsScrolledBottom(true);
        } else {
          setIsScrolledBottom(false);
        }
      } else {
        setIsScrolledBottom(true);
      }
    }

    if (typeof window !== "undefined") {
      const mutationObserver = new MutationObserver(scrollHandler);
      mutationObserver.observe(document.body, { childList: true });
      window.addEventListener("scroll", scrollHandler, []);

      return () => {
        window.removeEventListener("scroll", scrollHandler);
        mutationObserver.disconnect();
      };
    }

    return () => null;
  }, []);

  return isScrolledBottom;
}

export default useScrolledBottom;
